import type { PersonKind } from '@skystone/shared';
import { Badge } from '@/components/ui';

const KIND_LABEL: Record<PersonKind, string> = {
  human: 'Human',
  bot: 'Bot',
  service: 'Service',
};

const KIND_VARIANT: Record<PersonKind, 'default' | 'secondary' | 'warning'> = {
  human: 'default',
  bot: 'warning',
  service: 'secondary',
};

interface KindBadgeProps {
  kind: PersonKind;
}

export function KindBadge({ kind }: Readonly<KindBadgeProps>) {
  return <Badge variant={KIND_VARIANT[kind]}>{KIND_LABEL[kind]}</Badge>;
}
